import { Injectable } from '@angular/core';
import { GenericObjectModel } from '@cloudia-shared/models/core/generic-object.model';
import { map } from 'rxjs';
import { shareReplay, take } from 'rxjs/operators';
import { DropdownModules } from '../../../cloudia/src/app/core/services/dropdown/dropdown.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@envs/environment';
import { StaticObjectCollectionOutputModel } from '@cloudia-shared/apis/generated/static-object-api';

@Injectable({ providedIn: 'root' })
export class SelectFetchService {
  cache: { [key: string]: any } = {};

  constructor(private readonly http: HttpClient) {}

  listObjects(params: HttpParams, path: string) {
    return this.http
      .get<StaticObjectCollectionOutputModel>(
        environment.apiUrl + 'select-fetch/' + path,
        {
          observe: 'response',
          params,
        }
      )
      .pipe(shareReplay(1), take(1));
  }

  listStaticObjects(module: DropdownModules) {
    let params: HttpParams = new HttpParams();
    params = params
      .append('query', this.generateStaticObjectsQuery('{}', module) || '{}')
      .append('page', 0)
      .append('size', 9999);
    return this.http
      .get<StaticObjectCollectionOutputModel>(
        environment.apiUrl + 'select-fetch/static-objects',
        {
          observe: 'response',
          params,
        }
      )
      .pipe(
        shareReplay(1),
        take(1),
        map((data) => data.body.items as GenericObjectModel[])
      );
  }

  generateStaticObjectsQuery(
    searchQuery: string,
    moduleInput: DropdownModules
  ) {
    let search = JSON.parse(searchQuery ? searchQuery : '{}');
    const module = moduleInput.split(':');

    if (search.$and) {
      if (moduleInput.includes('so:')) {
        (search.$and as any[]).push(
          { relatedCollection: module[1] },
          { dictionary: module[2] }
        );
      }
    } else {
      if (searchQuery !== '{}' && moduleInput.includes('so:')) {
        search.$and = [
          { relatedCollection: module[1] },
          { dictionary: module[2] },
        ];
        if (search.$or) {
          search.$and.push({ $or: [...search.$or] });
        }
        delete search.$or;
      } else if (moduleInput.includes('so:')) {
        search = {
          $and: [{ relatedCollection: module[1] }, { dictionary: module[2] }],
        };
      }
    }

    return JSON.stringify(search);
  }
}
